import { Box } from "@mui/material";
import { Stage } from "../../../config/config";

export default function SupplementedFoodFacts () {
    const stage = (Stage).toLowerCase();
    const stageSegment = (stage === 'dev' || stage === 'test') ? `.azr.${stage}` : '';
    const imageDomain = `https://nutrition-calculator${stageSegment}.tis.coke.com/static/media`;

    return (
        <Box id="supplemented-food-facts">
            <img style={{marginBottom: '1em'}} src={`${imageDomain}/supplemented.png`} alt="Supplemented Foods Caution Identifier Required"/>
        </Box>
    )
}